import axios from "axios";

const baseApi = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout:10000,
    headers: {
        'Content-Type': 'application/json', // Define o tipo de conteúdo para JSON
        'Accept': 'application/json',      // Aceita respostas no formato JSON
        'x-password': process.env.VUE_APP_SENHA // Token Bearer (se necessário)
    }
})

export default baseApi